import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";

import AS from "../Login/Service/Authentication.js";
import PaginationButtons from "../../commons/components/pagination/PaginationButtons.jsx";
import { ROUTES } from "../../commons/constants/routes/routes.js";
import { getUpdatedSearchParam } from "../../commons/services/Router.js";

class SiteManagerMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      filteredItems: [],
      pageItems: [],
      totalCount: 0,
      currentPage: null,
      totalPageCount: 0,
      maxItemsPerPage: 10,
      keyword: "",
      orderType: "DESC",
    };
    this.getItems = this.getItems.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSortChange = this.handleSortChange.bind(this);
    this.updatePageParam = this.updatePageParam.bind(this);
  }

  async componentDidMount() {
    this.initPaginationSearchParam();
    await this.getItems();
  }

  componentDidUpdate(prevProps, prevState) {
    const isSamePageState = prevState.currentPage === this.state.currentPage;
    const isSamePageLocation = prevProps.location.search === this.props.location.search;
    if (!isSamePageState) {
      this.setPagination();
    }
    if (!isSamePageLocation) {
      const page = this.getPageSearchParam();
      if (page) {
        this.setState({ currentPage: Number(page) }, this.setPagination);
      }
    }
  }

  getPageSearchParam() {
    const params = new URLSearchParams(this.props.location.search);
    return params.get("page");
  }

  initPaginationSearchParam(initPage) {
    const page = initPage ? initPage : (this.getPageSearchParam() || 1);
    this.setState({ currentPage: Number(page) });
    return page;
  }

  updatePageParam(page) {
    const updatedParams = getUpdatedSearchParam({ page }, this.props.location);
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: updatedParams,
    });
  }

  setPagination() {
    const { filteredItems, currentPage } = this.state;
    const pageList = [];
    filteredItems.forEach((item, index) => {
      if (index % 10 === 0) {
        pageList.push([...filteredItems.slice(index, index + 10)]);
      }
    });
    this.setState({ pageItems: pageList[currentPage - 1] || [] });
  }

  async getItems() {
    const constructorId = AS.getLoggedInId();
    try {
      const res = await axios.get(`/api/account/account`, { params: { userType: "USR_S" } });
      const items = res.data.data;
      this.setState(
        { items, totalCount: items.length },
        this.handleSearch
      );
    } catch (e) {
      console.log(e);
    }
  }

  handleSortChange(e) {
    this.setState({ orderType: e.target.value }, this.handleSearch);
  }

  handleSearchChange(e) {
    this.setState({ [e.target.id]: e.target.value });
  }

  handleSearch(e) {
    if (e) e.preventDefault();
    const { items, orderType, keyword } = this.state;

    let filteredItems = items;

    if (keyword) {
      filteredItems = items.filter((item) =>
        item.userName && item.userName.includes(keyword)
      );
    }

    if (orderType === "ASC") {
      filteredItems = [...filteredItems].sort(
        (a, b) => new Date(a.createDt) - new Date(b.createDt)
      );
    } else {
      filteredItems = [...filteredItems].sort(
        (a, b) => new Date(b.createDt) - new Date(a.createDt)
      );
    }

    this.setState(
      {
        filteredItems,
        totalPageCount: Math.ceil(filteredItems.length / this.state.maxItemsPerPage),
      },
      this.setPagination
    );
  }

  render() {
    const { orderType, keyword, filteredItems, pageItems } = this.state;

    return (
      <Wrap>
        <div className="page-tit gray">
          <div className="container f-stack">
            <h2 className="tit">현장담당자 관리</h2>
            <Link to={ROUTES.SITE_MANAGER.CREATE} className="btn secondary">
              현장담당자 등록
            </Link>
          </div>
        </div>
        <div className="container">
          <div className="top-search">
            <p className="all">
              현장담당자 목록<span> 총 {this.state.totalCount}명</span>
            </p>
            <div className="search">
              <form onSubmit={this.handleSearch}>
                <select
                  id="orderType"
                  title="정렬선택"
                  value={orderType}
                  onChange={this.handleSortChange}
                >
                  <option value="DESC">최신순</option>
                  <option value="ASC">오래된순</option>
                </select>
                <div className="input-search">
                  <input
                    type="text"
                    id="keyword"
                    placeholder="검색어를 입력하세요"
                    value={keyword}
                    onChange={this.handleSearchChange}
                  />
                  <button type="submit" className="material-icons">
                    search
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="h-table">
              <colgroup>
                <col style={{ width: "5%" }} />
                <col style={{ width: "17%" }} />
                <col style={{ width: "22%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "13%" }} />
                <col style={{ width: "12%" }} />
                <col style={{ width: "8%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th>번호</th>
                  <th>담당자명</th>
                  <th>이메일</th>
                  <th>전화번호</th>
                  <th>등록일</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {pageItems.length > 0 ? (
                  pageItems.map((row, index) => (
                    <tr key={row.id}>
                      <td>
                        {this.state.totalCount -
                          ((this.state.currentPage - 1) * 10 + index)}
                      </td>
                      <td>{row.userName}</td>
                      <td className="ellipsis" title={row.email}>{row.email}</td>
                      <td>{row.phone}</td>
                     
                      <td>{row.createDt && new Date(row.createDt).toISOString().split("T")[0]}</td>
                      <td>
                        <Link
                          className="edit-link link-btn"
                          to={ROUTES.SITE_MANAGER.EDIT(row.id)}
                        >
                          수정
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">등록된 현장담당자가 없습니다.</td>
                  </tr>
                )}
              </tbody>
            </table>
            {filteredItems.length > 10 && (
              <PaginationButtons
                totalPageCount={this.state.totalPageCount}
                currentPage={this.state.currentPage}
                onChangePage={this.updatePageParam}
              />
            )}
          </div>
        </div>
      </Wrap>
    );
  }
}

const Wrap = styled.div`
  .page-tit .btn {
    width: 168px;
    border-radius: 8px;
  }
  .top-search .all {
    font-size: 15px;
    font-weight: bold;
    color: #191919;
    span {
      font-weight: normal;
      color: #888e98;
      display: inline-block;
      margin-left: 10px;
    }
  }
  .search form {
    select {
      border: 1px solid #d5d8de;
      margin-right: 12px;
    }
  }
  .ellipsis {
    max-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .link-btn {
    display: inline-block;
    font-size: 12px;
    width: 45px;
    padding: 3px 0;
    text-align: center;
    border-radius: 5px;
    text-decoration: none;
  }
  .edit-link {
    background-color: var(--secondary-500);
    border: 1px solid var(--secondary-500);
    color: #fff;
    &:hover {
      background-color: var(--secondary-600);
      border: 1px solid var(--secondary-600);
    }
  }
`;

export default withRouter(SiteManagerMain);
